import React, { useState } from 'react';
import { useUser } from '../../context/UserContext';
import { UserIcon } from 'lucide-react';
interface LoginFormProps {
  onLoginSuccess: () => void;
  onBackToSignup: () => void;
}
const LoginForm: React.FC<LoginFormProps> = ({
  onLoginSuccess,
  onBackToSignup
}) => {
  const {
    login
  } = useUser();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const validateEmail = (email: string): boolean => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!email) {
      setError('Email is required');
      return;
    }
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    setIsLoading(true);
    setError('');
    try {
      const success = await login(email);
      if (success) {
        onLoginSuccess();
      } else {
        setError('No account found with this email address.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred while trying to log in. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="text-center" data-id="element-355">
      <div className="flex justify-center mb-6" data-id="element-356">
        <div className="bg-blue-100 p-4 rounded-full" data-id="element-357">
          <UserIcon size={48} className="text-blue-600" data-id="element-358" />
        </div>
      </div>
      <h2 className="text-2xl font-bold mb-4 text-blue-700" data-id="element-359">Welcome Back</h2>
      <p className="mb-6 text-gray-600" data-id="element-360">
        Enter your email to continue your journey through the seven sacred
        gardens.
      </p>
      <form onSubmit={handleSubmit} noValidate data-id="element-361">
        <div className="mb-4" data-id="element-362">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" className={`w-full p-3 border rounded-lg focus:ring-blue-500 focus:border-blue-500 ${formSubmitted && (!email || !validateEmail(email)) ? 'border-red-300' : 'border-gray-300'}`} required data-id="element-363" />
          {formSubmitted && !email && <p className="mt-1 text-sm text-red-600 text-left" data-id="element-364">
              Email is required
            </p>}
        </div>
        {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-lg text-sm" data-id="element-365">
            {error}
          </div>}
        <button type="submit" disabled={isLoading} className="bg-blue-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-blue-700 transition-colors w-full font-medium mb-4" data-id="element-366">
          {isLoading ? 'Logging in...' : 'Continue Your Journey'}
        </button>
        <button type="button" onClick={onBackToSignup} className="text-gray-600 hover:text-gray-800 text-sm" data-id="element-367">
          New here? Create an account
        </button>
      </form>
    </div>;
};
export default LoginForm;